export default {
  message: 'Cannot have more than :commaSeparatedMax :attribute selected.',
  fn: (value, req) => {
    const values = value.split(',');
    return values.length <= parseInt(req, 10);
  }
};
